"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduledHeroEventStudentStatusEnum = void 0;
var ScheduledHeroEventStudentStatusEnum;
(function (ScheduledHeroEventStudentStatusEnum) {
    ScheduledHeroEventStudentStatusEnum["NOT_AT_EVENT"] = "not-at-event";
    ScheduledHeroEventStudentStatusEnum["AT_EVENT"] = "at-event";
    ScheduledHeroEventStudentStatusEnum["LEFT_EVENT"] = "left-event";
})(ScheduledHeroEventStudentStatusEnum || (exports.ScheduledHeroEventStudentStatusEnum = ScheduledHeroEventStudentStatusEnum = {}));
